(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("mouseDetected", [
    "$rootScope",
    function ($rootScope) {
      return {
        restrict: "A",
        scope: {
          onMouseDetected: "&mouseDetected",
        },
        link: function (scope) {
          $rootScope.$on("did-detect-mouse", function () {
            scope.onMouseDetected();
            scope.$apply();
          });
        },
      };
    },
  ]);
})(window.angular);
